"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Spinner = _interopRequireDefault(require("react-rainbow-components/components/Spinner"));

var SpinnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "AppSpinner__SpinnerContainer",
  componentId: "sc-1p9epqp-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;position:fixed;top:0;bottom:0;left:0;right:0;width:100%;height:100%;background-color:rgba(239,241,245,0.64);backdrop-filter:blur(5px);z-index:1000000;"]);

var AppSpinner = function AppSpinner(props) {
  var spinner = props.spinner;

  if (spinner) {
    return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(SpinnerContainer, {
      "data-cy": "app-spinner"
    }, spinner), document.body);
  }

  return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(SpinnerContainer, {
    "data-cy": "app-spinner"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)), document.body);
};

AppSpinner.propTypes = {
  /** The spinner to show when the app is loading. */
  spinner: _propTypes["default"].node
};
var _default = AppSpinner;
exports["default"] = _default;